import ApiServiceHelper from '../auth/apiServiceHelper'

const locationService = {
  async fetchDeliveryAddresses(userId) {
    const response = await ApiServiceHelper.getDeliveryAddress(`shop/addresses/delivery_addresses?user_id=${userId}`)
    return response.data.delivery_addresses
  },
  async fetchCollectionPoints(userId) {
    const response = await ApiServiceHelper.getCollectionPoint(`shop/addresses/collection_points?user_id=${userId}`)
    return response.data.collection_points
  },
  async fetchShops(shopId) {
    const response = await ApiServiceHelper.getCollectionPoint(`shop/addresses/shops?id=${shopId}`)
    return response.data.shops
  }
}

export default locationService



